import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class BlobService {
	protected _baseUrl = `${environment.apiUrl}`;
	protected _url = '';

	public set url(value: string) {
		if (value != '') {
			this._url = value;
		} else {
			throw new Error('La url no fue especificada.');
		}
	}

	public set baseUrl(value: string) {
		if (value != '') {
			this._baseUrl = value;
		} else {
			throw new Error('La base url no fue especificada.');
		}
	}

	constructor(private http: HttpClient) {}

	fileUpload(data: FormData): Observable<any> {
		if (this._url != '') {
			return this.http.post<Observable<any>>(
				`${this._baseUrl}/${this._url}`,
				data
			);
		}
		return of('No se pudo subir el archivo.');
	}
}
